<template>
  <div class="prize">
    <div>
      <PrizeSelect v-if="isShowSelect" />
      <PrizeDetail v-if="isShowDetail" :prizeUserCode="prizeUserCode" />
    </div>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import dayjs from 'dayjs'
const PrizeSelect = () => import('./PrizeSelect')
const PrizeDetail = () => import('./PrizeDetail')

// 達成賞賞品リストの取得
const getPrizeUserCode = (campaignId) => `
  query getPrizeUserCode {
    getPrizeUserCode(campaign_id: "${campaignId}") {
      prize_code
      prize_user {
        id
        meta
        prize_id
        prize_code_id
        prize_code_status
        email_send_at
      }
      prize_caution
    }
  }
`
const getPrizeUserCodeQuery = async (campaignId) => {
  const { data: { getPrizeUserCode: data } } = await GraphqlAPI(getPrizeUserCode(campaignId))
  return data
}

export default {
  name: 'prize',
  components: {
    PrizeSelect,
    PrizeDetail
  },
  data () {
    return {
      isShowSelect: false,
      isShowDetail: false,
      prizeUserCode: {}
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  async created () {
    // 達成賞の配布有無・参照可能期間
    const prizeUserCode = await getPrizeUserCodeQuery(this.campaign.id)
    const isPrizeSendPeriod = dayjs() > dayjs(this.campaign.prize_mail_send_date, 'YYYY-MM-DD')

    if (prizeUserCode && prizeUserCode.prize_code && isPrizeSendPeriod) {
      this.isShowDetail = true
      this.prizeUserCode = prizeUserCode
    } else {
      this.isShowSelect = true
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
